<template>
  <div id="error">
    <div class="error_icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#fff" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/><path d="M0 0h24v24H0z" fill="none"/></svg>
    </div>
    <p>{{ currentError }}</p>
    <button @click="backToMain()">Назад</button>
  </div>
</template>

<script>
export default {
  name: 'Error',
  computed: {
    currentError () {
      return this.$store.getters.currentError
    }
  },
  methods: {
    backToMain () {
      this.$store.dispatch('switchStatus', 0)
    }
  },
  mounted () {
    this.$store.dispatch('setErrorMsg')
  }
}
</script>

<style lang="scss" scoped>
  #error {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 12px;
    .error_icon {
      background: #DB1936;
      max-width: 100px;
      width: 100%;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 100%;
      svg {
        width: 70%;
        height: auto;
      }
    }
    p {
      font-family: 'AvantGardeGothicC';
      font-size: 36px;
      text-align: center;
      color: #000000;
      line-height: normal;
      margin-top: 62px;
    }
    button {
      font-family: 'Roboto';
      font-weight: 500;
      font-size: 24px;
      text-align: center;
      text-transform: uppercase;
      color: #ffffff;
      background: #DB1936;
      border: 1px solid #DB1936;
      border-radius: 6px;
      display: block;
      margin: 20px auto;
      padding: 23px 120px;
      transition: all 0.3s ease-in-out;
      outline: none;
      cursor: pointer;
    }
    button:hover {
      transform: scale(1.05)
                 translate3d(0,0,0);
      transition: all 0.1s ease-in-out;
    }
  }
  @media only screen and (max-width: 768px) {
    #error {
      margin-top: -100px;
      p {
        font-size: 24px;
      }
      button {
        padding: 20px;
      }
    }
  }
</style>
